module.exports = __webpack_public_path__ + "img/dd.b0723358.png";